<template>
  <div class="rk-page" :class="$vuetify.theme.dark ? 'rk-page--dark' : 'rk-page--light'">

    <!-- HERO -->
    <div class="rk-hero">
      <v-btn text dark small class="rk-back" @click="$router.back()">
        <v-icon left small>mdi-arrow-left</v-icon> Volver
      </v-btn>
      <div class="rk-hero__content">
        <div class="rk-hero__trophy">🏆</div>
        <div class="rk-hero__title">Ranking de Inscripciones</div>
        <div class="rk-hero__sub">Top 3 asesores &nbsp;·&nbsp; <b>{{ mesActual }}</b></div>
      </div>
    </div>

    <!-- LOADING -->
    <div v-if="cargando" class="rk-loading">
      <v-progress-circular indeterminate color="amber darken-1" size="60" width="5" />
      <div class="rk-loading__text">Calculando ranking...</div>
    </div>

    <!-- GRID DE SEDES -->
    <div v-else class="rk-grid">
      <div v-for="sede in sedesall" :key="sede.id" class="rk-card">
        <div class="rk-card__header">
          <v-icon small color="rgba(255,255,255,0.8)" class="mr-1">mdi-map-marker</v-icon>
          {{ sede.nombre }}
        </div>
        <!-- Podium: 2º izquierda · 1º centro · 3º derecha -->
        <div class="rk-podium">
          <div v-for="pos in [1, 0, 2]" :key="pos"
            class="rk-slot" :class="'rk-slot--' + (pos + 1)">
            <template v-if="sede.asesores[pos]">
              <v-icon class="rk-medal" :class="'rk-medal--' + (pos + 1)">mdi-trophy</v-icon>
              <div class="rk-avatar-ring" :class="'rk-avatar-ring--' + (pos + 1)">
                <v-img :src="sede.asesores[pos].info.foto"
                  :width="pos === 0 ? 84 : 70" :height="pos === 0 ? 84 : 70"
                  style="border-radius:50%;"
                >
                  <template #placeholder>
                    <v-icon :size="pos === 0 ? 48 : 40" color="grey lighten-2">mdi-account-circle</v-icon>
                  </template>
                </v-img>
              </div>
              <div class="rk-slot__name">{{ sede.asesores[pos].info.nombre }}</div>
              <div class="rk-slot__total" :class="'rk-slot__total--' + (pos + 1)">
                {{ sede.asesores[pos].total }}
                <span class="rk-slot__label">inscr.</span>
              </div>
              <div class="rk-tags">
                <span v-if="sede.asesores[pos].dip"  class="rk-tag rk-tag--d">Dip {{ sede.asesores[pos].dip }}</span>
                <span v-if="sede.asesores[pos].maes" class="rk-tag rk-tag--m">Maes {{ sede.asesores[pos].maes }}</span>
                <span v-if="sede.asesores[pos].esp"  class="rk-tag rk-tag--e">Esp {{ sede.asesores[pos].esp }}</span>
                <span v-if="sede.asesores[pos].cur"  class="rk-tag rk-tag--c">Cur {{ sede.asesores[pos].cur }}</span>
              </div>
              <div class="rk-pedestal" :class="'rk-pedestal--' + (pos + 1)">{{ pos + 1 }}</div>
            </template>
            <template v-else>
              <div class="rk-slot__empty">—</div>
              <div class="rk-pedestal" :class="'rk-pedestal--' + (pos + 1)">{{ pos + 1 }}</div>
            </template>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import gql from 'graphql-tag';

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const FC_IDS = [5071, 72, 5281, 8382];

export default {
  data() {
    return {
      location_user_pick: process.env.VUE_APP_URL_USERPICK,
      cargando: true,
      sedesall: [],
    };
  },
  computed: {
    mesActual() {
      return MESES[new Date().getMonth()];
    },
  },
  methods: {
    fechasDelMes() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(Math.max(now.getDate(), 2)).padStart(2, '0');
      return { ini: `${y}-${m}-01`, fin: `${y}-${m}-${d}` };
    },

    async getsedes() {
      this.cargando = true;
      const sqlSedes = gql`query { getSedes(estado:true){ id, nombre } }`;
      let sedes;
      try {
        const res = await this.$apollo.mutate({ mutation: sqlSedes });
        sedes = res.data.getSedes;
      } catch (e) {
        window.console.error(e);
        this.cargando = false;
        return;
      }

      const { ini, fin } = this.fechasDelMes();
      const fragments = sedes.map((s, i) => {
        const alias = 's' + i;
        
        return `${alias}:getInscripcionesBySede(sede:${s.id},fechas:{fecha_ini:"${ini}",fecha_fin:"${fin}"}){
          id, estado_ins,
          asesor{ id, nombres, pri_apellido, usuario{ foto } },
          programa{ id, sede{ id, nombre }, postgrado{ id, nombre, categoria{ id, nombre } } }
        }`;
      }).join('\n');

      const sqlIns = gql`query { ${fragments} }`;
      this.getinscritos(sqlIns);
    },

    getinscritos(sql) {
      this.$apollo.mutate({ mutation: sql }).then(({ data }) => {
        const sedes = [];
        Object.values(data).forEach(inscripciones => {
          const ins = inscripciones.filter(e => {
            if (!e.estado_ins) return false;
            if (e.programa.sede.id === 2) return !FC_IDS.includes(e.asesor.id);
            return true;
          });

          ins.forEach(e => {
            const nom = `${e.asesor.nombres} ${e.asesor.pri_apellido}`;
            let sede = sedes.find(x => x.id === e.programa.sede.id);
            if (!sede) {
              sede = { id: e.programa.sede.id, nombre: e.programa.sede.nombre, asesores: [] };
              sedes.push(sede);
            }

            let ase = sede.asesores.find(x => x.info.id === e.asesor.id);
            if (!ase) {
              const foto = e.asesor.usuario?.foto?.includes('.')
                ? this.location_user_pick + e.asesor.usuario.foto
                : this.location_user_pick + 'userdefault.png';
              ase = { info: { id: e.asesor.id, nombre: nom, foto }, dip: 0, maes: 0, esp: 0, cur: 0, total: 0 };
              sede.asesores.push(ase);
            }

            const cat = e.programa.postgrado.categoria.id;
            if (cat === 1) ase.dip++;
            else if (cat === 2) ase.esp++;
            else if (cat === 3) ase.maes++;
            else ase.cur++;
            ase.total = ase.dip + ase.esp + ase.maes + ase.cur;
          });

          sedes.forEach(s => {
            s.asesores.sort((a, b) => b.total - a.total);
            s.asesores = s.asesores.slice(0, 3);
          });
        });

        this.sedesall = sedes;
        this.cargando = false;
      }).catch(e => {
        window.console.error(e);
        this.cargando = false;
      });
    },
  },
  mounted() {
    this.getsedes();
  },
};
</script>


<style scoped>
/* ── Página ──────────────────────────────────────────────────────────── */
.rk-page {
  min-height: 100vh;
  padding-bottom: 48px;
}
.rk-page--dark  { background: #0f1b2d; }
.rk-page--light { background: #f0f4f8; }

/* ── Hero ────────────────────────────────────────────────────────────── */
.rk-hero {
  background: linear-gradient(135deg, #0d1b2a 0%, #1a3550 40%, #1b4f72 100%);
  padding: 24px 24px 36px;
  text-align: center;
  position: relative;
  border-bottom: 2px solid rgba(255, 200, 0, 0.25);
}
.rk-back {
  position: absolute;
  top: 12px;
  left: 12px;
  opacity: 0.75;
  font-size: 0.8rem;
}
.rk-hero__content { display: inline-block; }
.rk-hero__trophy { font-size: 3.5rem; line-height: 1; margin-bottom: 4px; }
.rk-hero__title {
  font-size: 1.7rem;
  font-weight: 900;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.rk-hero__sub {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 4px;
}
.rk-hero__sub b { color: #FFD700; }

/* ── Loading ─────────────────────────────────────────────────────────── */
.rk-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
}
.rk-loading__text {
  margin-top: 16px;
  font-size: 0.9rem;
  letter-spacing: 0.04em;
}
.rk-page--dark  .rk-loading__text { color: rgba(255,255,255,0.5); }
.rk-page--light .rk-loading__text { color: #90a4ae; }

/* ── Grid de sedes ───────────────────────────────────────────────────── */
.rk-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 28px 20px 0;
  justify-content: center;
}
.rk-card {
  border-radius: 16px;
  overflow: hidden;
  width: 320px;
  flex-shrink: 0;
}
.rk-page--dark  .rk-card { background: #162032; box-shadow: 0 8px 32px rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.07); }
.rk-page--light .rk-card { background: #ffffff; box-shadow: 0 4px 20px rgba(0,0,0,0.10); border: 1px solid rgba(0,0,0,0.07); }
.rk-card__header {
  background: linear-gradient(90deg, #1a3a5c, #1b5e9e);
  padding: 10px 16px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  display: flex;
  align-items: center;
}

/* ── Podium ──────────────────────────────────────────────────────────── */
.rk-podium {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 0;
  padding: 20px 8px 0;
}
.rk-slot {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 0 4px;
}

/* ── Medalla ─────────────────────────────────────────────────────────── */
.rk-medal { font-size: 1.6rem !important; margin-bottom: 4px; }
.rk-medal--1 { color: #FFD700 !important; filter: drop-shadow(0 0 6px rgba(255,200,0,0.7)); }
.rk-medal--2 { color: #C0C0C0 !important; filter: drop-shadow(0 0 4px rgba(180,180,180,0.5)); }
.rk-medal--3 { color: #CD7F32 !important; filter: drop-shadow(0 0 4px rgba(180,100,30,0.5)); }

/* ── Avatar ──────────────────────────────────────────────────────────── */
.rk-avatar-ring {
  border-radius: 50%;
  padding: 3px;
  margin-bottom: 6px;
}
.rk-avatar-ring--1 { background: linear-gradient(135deg, #FFD700, #FFA500); box-shadow: 0 0 14px rgba(255, 200, 0, 0.6); }
.rk-avatar-ring--2 { background: linear-gradient(135deg, #C0C0C0, #9E9E9E); box-shadow: 0 0 10px rgba(180,180,180,0.4); }
.rk-avatar-ring--3 { background: linear-gradient(135deg, #CD7F32, #8B4513); box-shadow: 0 0 8px rgba(180,100,30,0.4); }
.rk-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  background: #263748;
}
.rk-slot--1 .rk-avatar { width: 84px; height: 84px; }

/* ── Nombre y total ──────────────────────────────────────────────────── */
.rk-slot__name {
  font-size: 0.72rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  margin-bottom: 4px;
  max-width: 95px;
}
.rk-page--dark  .rk-slot__name { color: rgba(255,255,255,0.88); }
.rk-page--light .rk-slot__name { color: #37474f; }
.rk-slot__total {
  font-size: 1.5rem;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 2px;
}
.rk-slot__total--1 { color: #FFD700; }
.rk-slot__total--2 { color: #C0C0C0; }
.rk-slot__total--3 { color: #CD7F32; }
.rk-slot__label { font-size: 0.6rem; font-weight: 400; opacity: 0.7; margin-left: 2px; }

/* ── Tags breakdown ──────────────────────────────────────────────────── */
.rk-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  justify-content: center;
  margin-bottom: 10px;
}
.rk-tag {
  font-size: 0.6rem;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 10px;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
/* dark */
.rk-page--dark .rk-tag--d { background: rgba(33,150,243,0.25); color: #90CAF9; }
.rk-page--dark .rk-tag--m { background: rgba(156,39,176,0.25); color: #CE93D8; }
.rk-page--dark .rk-tag--e { background: rgba(0,150,136,0.25);  color: #80CBC4; }
.rk-page--dark .rk-tag--c { background: rgba(255,152,0,0.25);  color: #FFCC80; }
/* light */
.rk-page--light .rk-tag--d { background: #E3F2FD; color: #1565C0; }
.rk-page--light .rk-tag--m { background: #F3E5F5; color: #6A1B9A; }
.rk-page--light .rk-tag--e { background: #E0F2F1; color: #00695C; }
.rk-page--light .rk-tag--c { background: #FFF3E0; color: #E65100; }

/* ── Pedestal ────────────────────────────────────────────────────────── */
.rk-pedestal {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 900;
  color: rgba(255,255,255,0.7);
  border-radius: 6px 6px 0 0;
}
.rk-pedestal--1 { height: 72px; background: linear-gradient(180deg, #c9972a, #7a5a10); }
.rk-pedestal--2 { height: 52px; background: linear-gradient(180deg, #8a8a8a, #555555); }
.rk-pedestal--3 { height: 36px; background: linear-gradient(180deg, #7a4a20, #4a2a0a); }

/* ── Slot vacío ──────────────────────────────────────────────────────── */
.rk-slot__empty { font-size: 1.4rem; padding-bottom: 8px; }
.rk-page--dark  .rk-slot__empty { color: rgba(255,255,255,0.15); }
.rk-page--light .rk-slot__empty { color: rgba(0,0,0,0.15); }

/* ── Avatar fondo fallback ───────────────────────────────────────────── */
.rk-page--dark  .rk-avatar { background: #263748; }
.rk-page--light .rk-avatar { background: #e8edf2; }
</style>
